/**
 * AppLayout Component
 * Main layout wrapper with header, navigation, and footer
 */

import React from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Container,
  Divider,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface AppLayoutProps {
  children: React.ReactNode;
  showNavigation?: boolean;
}

function AppLayout({ children, showNavigation = true }: AppLayoutProps): JSX.Element {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {showNavigation && (
      <AppBar position="static">
        <Toolbar>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexGrow: 1,
              cursor: 'pointer',
              transition: 'opacity 0.3s',
              '&:hover': { opacity: 0.8 },
            }}
            onClick={() => navigate('/')}
          >
            <img src="/cla-logo.png" alt="CLA" style={{ height: 36, width: 36, objectFit: 'contain' }} />

            <Typography variant="h6" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
              Quiz Builder
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      )}

      <Box sx={{ flex: 1 }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          {children}
        </Container>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: theme.palette.grey[100],
          borderTop: `1px solid ${theme.palette.divider}`,
          textAlign: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
          <img src="/cla-logo.png" alt="CLA" style={{ height: 24, width: 24, objectFit: 'contain' }} />
          <Typography variant="body2" color="textSecondary">
            CLA Quiz Builder v1.0.0
          </Typography>
        </Box>
        <Typography variant="caption" color="textSecondary">
          © 2026 Clifton Larson Allen LLP. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}

export default AppLayout;
